module.exports = __webpack_public_path__ + "img/banner9.87379081.jpg";